module.exports = __webpack_public_path__ + "img/emp5-2.f7276d00.jpg";